export enum ErrorTag {
  CARDINAL = "cardinal",
  GATEWAY = "gateway",
  INTERNAL = "internal",
  MISCONFIGURATION = "misconfiguration",
  PAYMENT = "payment",
  PAYMENT_INIT = "payment_init",
  TIMEOUT = "timeout",
}
